 window.CAPcars = {
        "Audi": [
             {
                value: "a3",
                name: "A3",
                series: [
                    {
                        name: "A3 - 8P.5 (2009 - 2013)",
                        value: "a3-8p-5",
                        title: "AUDI - 8P.5 (2009 -2013) - A3",
                        description:"Transform your 2009-2013 8P.5 Audi A3 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A3 - 8V (2014 - 2016)",
                        value: "a3-8v",
                        title: "AUDI - 8V (2014 - 2016) - A3",
                        description:"Transform your 2014-2016 8V Audi A3 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A3 - 8V.5 (2017 - 2020)",
                        value: "a3-8v-5",
                        title: "AUDI - 8V.5 (2017 - 2020) - A3",
                        description:"Transform your 2017-2020 8V.5 Audi A3 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A3 - 8Y (2021 - 2024)",
                        value: "a3-8y",
                        title: "AUDI - 8Y (2021 - 2024) - A3",
                        description:"Transform your 2021-2024 8Y Audi S3 with CAP's high-quality Grille into the beautiful RS Honeycomb design of the RS3. Available in gloss black our RS3 front grille will make your S3 look much more aggressive."
                    },{
                        name: "A3 - 8Y.5 (2025-2026)",
                        value: "a3-8y-5",
                        title: "AUDI - 8Y.5 (2025-2026) - A3",
                        description:"Transform your 2025-2026 8Y.5 Audi S3 with CAP's high-quality Grille into the beautiful RS Honeycomb design of the RS3. Available in gloss black our RS3 front grille will make your S3 look much more aggressive."
                    }
                ]
            },
             {
                value: "s3",
                name: "S3",
                series: [
                    {
                        name: "S3 - 8V (2015 - 2016)",
                        value: "s3-8v",
                        title: "AUDI - 8V (2015 - 2016) - S3",
                        description:"Transform your 2015-2016 8V Audi S3 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."

                    },
                    {
                        name: "S3 - 8V.5 (2017 - 2020)",
                        value: "s3-8v-5",
                        title: "AUDI - 8V.5 (2017 - 2020) - S3",
                        description:"Transform your 2017-2020 8V.5 Audi S3 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."

                    },
                    {
                        name: "S3 - 8Y (2021 - 2024)",
                        value: "s3-8y",
                        title: "AUDI - 8Y (2021 - 2024) - S3",
                        description:"Transform your 2021-2024 8Y Audi S3 with CAP's high-quality Grille into the beautiful RS Honeycomb design of the RS3. Available in gloss black our RS3 front grille will make your S3 look much more aggressive."
                    }, {
                        name: "S3 - 8Y.5 (2025-2026)",
                        value: "s3-8y-5",
                        title: "AUDI - 8Y.5 (2025-2026) - S3",
                        description:"Transform your 2025-2026 8Y.5 Audi S3 with CAP's high-quality Grille into the beautiful RS Honeycomb design of the RS3. Available in gloss black our RS3 front grille will make your S3 look much more aggressive."
                    }
                ]
            },
            {
                value: "rs3",
                name: "RS3",
                series: [
                    {
                        name: "RS3 - 8V.5 (2018 - 2020)",
                        value: "rs3-8v-5",
                        title: "AUDI - 8V.5 (2018 - 2020) - RS3",
                        description:"Transform your 2017-2020 8V.5 Audi RS3 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."

                    }, {
                        name: "RS3 - 8Y (2021 - 2024)",
                        value: "rs3-8y",
                        title: "AUDI - 8Y (2021 - 2024) - RS3",
                        description:"Transform your 2021-2024 8Y Audi RS3 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "RS3 - 8Y.5 (2025+)",
                        value: "rs3-8y-5",
                        title: "AUDI - 8Y.5 (2025+) - RS3",
                        description:"Transform your 2025+ 8Y Audi RS3 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    // {
                    //     name: "RS3 - 8Y (2021 - 2023)",
                    //     value: "rs3-8y",
                    //     title: "AUDI - 8Y (2021 - 2023) - RS3",
                    //     description:"Transform your 2021-2023 8Y Audi RS3 with CAP's high-quality Grille into the beautiful RS Honeycomb design of the RS3. Available in gloss black our RS3 front grille will make your S3 look much more aggressive."
                    // }
                ]
            },

           {
                value: "a4",
                name: "A4",
                series: [
                    {
                        name: "A4 - B8 (2009 - 2012)",
                        value: "a4-b8",
                        title: "AUDI - B8 (2009 - 2012) - A4",
                        description:"Transform your 2009-2012 B8 Audi A4 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A4 - B8.5 (2013 - 2016)",
                        value: "a4-b8-5",
                        title: "AUDI - B8.5 (2013 - 2016) - A4",
                        description:"Transform your 2013-2016 B8.5 Audi A4 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A4 - B9 (2017 - 2019)",
                        value: "a4-b9",
                        title: "AUDI - B9 (2017 - 2019) - A4",
                        description:"Transform your 2017-2019 B9 Audi A4 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A4 - B9.5 (2020-2024)",
                        value: "a4-b9-5",
                        title: "AUDI - B9.5 (2020-2024) - A4",
                        description:"Transform your 2020-2024 B9.5 Audi A4 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    }
                ]
            }, 
          {
                value: "a4allroad",
                name: "A4 AllRoad",
                series: [
                    {
                        name: "A4 Allroad - B8.5 (2013 - 2016)",
                        value: "a4-allroad-b8-5",
                        title: "AUDI - B8.5 (2013 - 2016) - A4 Allroad",
                        description:"Transform your 2013-2016 B8.5 Audi A4 Allroad with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A4 Allroad - B9.5 (2020-2025)",
                        value: "a4-allroad-b9-5",
                        title: "AUDI - B9.5 (2020-2024) - A4 Allroad",
                        description:"Transform your 2020-2024 B9.5 Audi A4 Allroad with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    }
                ]
            },
            {
                value: "s4",
                name: "S4",
                series: [
                    {
                        name: "S4 - B8 (2010 - 2012)",
                        value: "s4-b8",
                        title: "AUDI - B8 (2010 - 2012) - S4",
                        description:"Transform your 2009-2012 B8 Audi S4 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "S4 - B8.5 (2013 - 2016)",
                        value: "s4-b8-5",
                        title: "AUDI - B8.5 (2013 - 2016) - S4",
                        description: "Transform your 2013-2017 B8.5 Audi S4 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint.",

                    },
                    {
                        name: "S4 - B9 (2018 - 2019)",
                        value: "s4-b9",
                        title: "AUDI - B9 (2018 - 2019) - S4",
                        description:"Transform your 2017-2019 B9 Audi S4 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."

                    },
                    {
                        name: "S4 - B9.5 (2020-2025)",
                        value: "s4-b9-5",
                        title: "AUDI - B9.5 (2020-2024) - S4",
                        description:"Transform your 2020-2024 B9.5 Audi S4 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."

                    }
                ]
            },

           {
                value: "a5",
                name: "A5",
                series: [
                    {
                        name: "A5 - B8 (2008 - 2012)",
                        value: "a5-b8",
                        title: "AUDI - B8 (2008 - 2012) - A5",
                        description:"Transform your 2008-2012 B8 Audi A5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A5 - B8.5 (2013 - 2017)",
                        value: "a5-b8-5",
                        title: "AUDI - B8.5 (2013 - 2017) - A5",
                        description:"Transform your 2013-2017 B8.5 Audi A5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                        
                    },
                    {
                        name: "A5 - B9 (2018 - 2019)",
                        value: "a5-B9",
                        title: "AUDI - B9 (2018 - 2019) - A5",
                        description:"Transform your 2018-2019 B9 Audi A5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A5 - B9.5 (2020-2024)",
                        value: "s5-b9-5",
                        title: "AUDI - B9.5 (2020-2024) - A5",
                        description:"Transform your 2020-2024 B9.5 Audi A5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    }
                ]
            },
            {
                value: "s5",
                name: "S5",
                series: [
                    {
                        name: "S5 - B8 (2008 - 2012)",
                        value: "s5-b8",
                        title: "AUDI - B8 (2008 - 2012) - S5",
                        description:"Transform your 2008-2012 B8 Audi S5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "S5 - B8.5 (2013 - 2017)",
                        value: "s5-b8-5",
                        title:"AUDI - B8.5 (2013 - 2017) - S5",
                        description:"Transform your 2013-2017 B8.5 Audi S5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    }, 
                    {
                        name: "S5 - B9 (2018 - 2019)",
                        value: "s5-b9",
                        title: "AUDI - B9 (2018 - 2019) - S5",
                        description:"Transform your 2018-2019 B9 Audi S5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "S5 - B9.5 (2020-2024)",
                        value: "s5-b9-5",
                        title: "AUDI - B9.5 (2020+) - S5",
                        description:"Transform your 2020-2024 B9.5 Audi S5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    }
                ]
            },
            {
                value: "rs5",
                name: "RS5",
                series: [
                    {
                        name: "RS5 - B8.5 (2013 - 2017)",
                        value: "rs5-b8-5",
                        title:"AUDI - B8.5 (2013 - 2017) - RS5",
                        description: "Transform your 2013-2017 B8.5 Audi RS5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint.",

                    },
                    {
                        name: "RS5 - B9 (2018 - 2020)",
                        value: "rs5-b9",
                        title: "AUDI - B9 (2018 - 2020) - RS5",
                        description:"Transform your 2018-2020 B9 Audi RS5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "RS5 - B9.5 (2021-2024)",
                        value: "rs5-b9-5",
                        title: "AUDI - B9.5 (2021-2024) - RS5",
                        description:"Transform your 2021-2024 B9.5 Audi RS5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    }
                ]
            },
            {
                value: "a6",
                name: "A6",
                series: [
                    {
                        name: "A6 - C6 (2005 - 2011)",
                        value: "a6-c6",
                        title: "AUDI - C6 (2005 - 2011) - A6",
                        urlPart: "2005-2011-c6-audi-a6-s6",
                        description:"Transform your 2005-2011 C6 Audi A6 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A6 - C7 (2012 - 2015)",
                        value: "a6-c7",
                        title: "AUDI - C7 (2012 - 2015) - A6",
                        urlPart: "2005-2011-c6-audi-a6-s6",
                        description:"Transform your 2012-2015 C7 Audi A6 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A6 - C7.5 (2016 - 2018)",
                        value: "a6-c7-5",
                        title: "AUDI - C7.5 (2016 - 2018) - A6",
                        description:"Transform your 2016-2018 C7.5 Audi A6 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A6 - C8 (2019-2023)",
                        value: "a6-c8",
                        title: "AUDI - C8 (2019-2023) - A6",
                        description:"Transform your 2019-2023 C8 Audi A6 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    }
                ]
            },
          {
                value: "a6allroad",
                name: "A6 AllRoad",
                series: [
                   {
                        name: "A6 Allroad - C8 (2019-2023)",
                        value: "a6-allroad-c8",
                        title: "AUDI - C8 (2019-2023) - A6 Allroad",
                        description:"Transform your 2019-2023 C8 Audi A6 Allroad with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    }
                ]
            },
            {
                value: "s6",
                name: "S6",
                series: [
                    {
                        name: "S6 - C6 (2007 - 2011)",
                        value: "s6-c6",
                        title: "AUDI - C6 (2007 - 2011) - S6",
                        description:"Transform your 2007-2011 C6 Audi S6 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."

                    },
                    {
                        name: "S6 - C7 (2013 - 2015)",
                        value: "s6-c7",
                        title: "AUDI - C7 (2013 - 2015) - S6",
                        description:"Transform your 2013-2015 C7 Audi S6 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "S6 - C7.5 (2016 - 2018)",
                        value: "s6-c7-5",
                        title: "AUDI - C7.5 (2016 - 2018) - S6",
                        description:"Transform your 2016-2018 C7.5 Audi S6 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "S6 - C8 (2020-2023)",
                        value: "s6-c8",
                        title: "AUDI - C8 (2020-2023) - S6",
                        description:"Transform your 2020-2023 C8 Audi S6 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    }
                ]
            },
            {
                value: "a7",
                name: "A7",
                series: [
                    {
                        name: "A7 - C7 (2012 - 2015)",
                        value: "a7-c7",
                        title: "AUDI - C7 (2012 - 2015) - A7",
                        descrption:"Transform your 2012-2015 C7 Audi A7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A7 - C7.5 (2016 - 2018)",
                        value: "a7-c7-5",
                        title: "AUDI - C7.5 (2016 - 2018) - A7",
                        description:"Transform your 2016-2018 C7.5 Audi A7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "A7 - C8 (2019-2023)",
                        value: "a7-c8",
                        title: "AUDI - C8 (2019-2023) - A7",
                        description:"Transform your 2019-2022 C8 Audi A7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                ]
            },
            {
                value: "s7",
                name: "S7",
                series: [
                    {
                        name: "S7 - C7 (2013 - 2015)",
                        value: "s7-c7",
                        title: "AUDI - C7 (2013 - 2015) - S7",
                        description:"Transform your 2013-2015 C7 Audi S7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "S7 - C7.5 (2016 - 2018)",
                        value: "s7-c7-5",
                        title: "AUDI - C7.5 (2016 - 2018) - S7",
                        description:"Transform your 2016-2018 C7.5 Audi S7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "S7 - C8 (2020-2023)",
                        value: "s7-c8",
                        title: "AUDI - C8 (2020-2023) - S7",
                        description:"Transform your 2020-2023 C8 Audi S7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                ]
            },
            {
                value: "rs7",
                name: "RS7",
                series: [
                    {
                        name: "RS7 - C7 (2013 - 2015)",
                        value: "rs7-c7",
                        title: "AUDI - C7 (2013 - 2015) - RS7",
                        description:"Transform your 2013-2015 C7 Audi RS7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "RS7 - C7.5 (2016 - 2018)",
                        value: "rs7-c7-5",
                        title: "AUDI - C7.5 (2016 - 2018) - RS7",
                        description:"Transform your 2016-2018 C7.5 Audi RS7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "RS7 - C8 (2020-2023)",
                        value: "rs7-c8",
                        title: "AUDI - C8 (2020-2023) - RS7",
                        description:"Transform your 2020-2023 C8 Audi RS7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    }
                ]
            },
            {
                value: "a8",
                name: "A8",
                series: [
                    {
                        name: "A8 - D4 (2011 - 2014)",
                        value: "a8-d4",
                        title: "AUDI - D4 (2011 - 2014) - A8",
                    },
                    {
                        name: "A8 - D4.5 (2015 - 2018)",
                        value: "a8-d4-5",
                        title: "AUDI - D4.5 (2015 - 2018) - A8",
                    },
                    {
                        name: "A8 - D5 (2019-2021)",
                        value: "a8-d5",
                        title: "AUDI - D5 (2019-2021+) - A8",
                    },
                ]
            },
            {
                value: "s8",
                name: "S8",
                series: [
                    {
                        name: "S8 - D4 (2013 - 2014)",
                        value: "s8-d4",
                        title: "AUDI - D4 (2013 - 2014) - S8",
                    },
                    {
                        name: "S8 - D4.5 (2015 - 2018)",
                        value: "a8-d4-5",
                        title: "AUDI - D4.5 (2015 - 2018) - S8",
                    },
                    {
                        name: "S8 - D5 (2020-2021)",
                        value: "a8-d5",
                        title: "AUDI - D5 (2020-2021+) - S8",
                    },
                ]
            },
            {
                value: "q3",
                name: "Q3",
                series: [
                  {
                        name: "Q3 - 8U (2013 - 2015)",
                        value: "q3-8u",
                        title: "AUDI - 8U (2013 - 2015) - Q3",
                        description:"Transform your 2013-2015 8U Audi Q3 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    }, 
                    {
                        name: "Q3 - 8U.5 (2016 - 2018)",
                        value: "q3-8u-5",
                        title: "AUDI - 8U.5 (2016 - 2018) - Q3",
                        description:"Transform your 2016-2018 8U.5 Audi Q3 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    {
                        name: "Q3 - F3 (2019 - 2023)",
                        value: "q3-f3",
                        title: "AUDI - F3 (2019 - 2023) - Q3",
                    },
                ]
            },
            {
                value: "q5",
                name: "Q5",
                series: [
                    {
                        name: "Q5 - 8R (2009 - 2012)",
                        value: "q5-8r",
                        title: "AUDI - 8R (2009 - 2012) - Q5",
                        description:"Transform your 2009-2012 8R/B8 Audi Q5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "Q5 - 8R.5 (2013 - 2017)",
                        value: "q5-8r-5",
                        title: "AUDI - 8R.5 (2013 - 2017) - Q5",
                        description:"Transform your 2013-2017 8R.5/B8.5 Audi Q5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "Q5 - B9 (2018 - 2020)",
                        value: "q5-b9",
                        title: "AUDI - B9 (2018 - 2020) - Q5",
                        description:"Transform your 2018-2019 B9 Audi Q5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    {
                        name: "Q5 - B9.5 (2021 - 2023)",
                        value: "q5-b9-5",
                        title: "AUDI - B9.5 (2021 - 2023) - Q5",
                        description:"Transform your 2020-2023 B9.5 Audi Q5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                ]
            },
            {
                value: "sq5",
                name: "SQ5", 
                series: [
                    {
                        name: "SQ5 - 8R.5 (2013 - 2017)",
                        value: "sq5-8r-5",
                        title: "AUDI - 8R.5 (2013 - 2017) - SQ5",
                        description:"Transform your 2013-2017 8R.5/B8.5 Audi SQ5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                    {
                        name: "SQ5 - B9 (2018 - 2020)",
                        value: "sq5-b9",
                        title: "AUDI - B9 (2018 - 2020) - SQ5",
                        description:"Transform your 2018-2019 B9 Audi SQ5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    {
                        name: "SQ5 - B9.5 (2021 - 2023)",
                        value: "sq5-b9-5",
                        title: "AUDI - B9.5 (2021 - 2023) - SQ5",
                        description:"Transform your 2020-2023 B9.5 Audi SQ5 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                ]
            },
            {
                value: "Q7/SQ7",
                name: "Q7/SQ7",
                series: [
                    {
                        name: "Q7 - 4L (2007 - 2009)",
                        value: "q7-4l",
                        title: "AUDI - 4L (2007 - 2009) - Q7",
                        description:"Transform your 2007-2015 4L Audi Q7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    {
                        name: "Q7 - 4L.5 (2010 - 2015)",
                        value: "q7-4L-5",
                        title: "AUDI - 4L.5 (2010 - 2015) - Q7",
                        description:"Transform your 2007-2015 4L Audi Q7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    {
                        name: "Q7 - 4M (2016 - 2019)",
                        value: "q7-4m",
                        title: "AUDI - 4M (2016 - 2019) - Q7",
                        description:"Transform your 2016-2019 4M Audi Q7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    {
                        name: "Q7 - 4M.5 (2020 - 2023)",
                        value: "q7-4M-5",
                        title: "AUDI - 4M.5 (2020 - 2023) - Q7",
                        description:"Transform your 2020-2023 4M.5 Audi Q7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                     {
                        name: "SQ7 - 4M.5 (2020 - 2023)",
                        value: "sq7-4M-5",
                        title: "AUDI - 4M.5 (2020 - 2023) - SQ7",
                        description:"Transform your 2020-2023 4M.5 Audi SQ7 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                ]
            },
          {
                value: "Q8",
                name: "Q8",
                series: [
                   {
                        name: "Q8 - 4M (2019 - 2023)",
                        value: "q8-4M",
                        title: "AUDI - 4M (2019 - 2023) - Q8",
                        description:"Transform your 2019-2023 4M Audi Q8 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    
                ]
            },
           {
                value: "SQ8",
                name: "SQ8",
                series: [
                   {
                        name: "SQ8 - 4M (2019 - 2023)",
                        value: "sq8-4M",
                        title: "AUDI - 4M (2019 - 2023) - SQ8",
                        description:"Transform your 2019-2023 4M Audi SQ8 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    
                ]
            },

            // { 
            //     value: "tt",
            //     name: "TT",
            //     series: [
            //         {
            //             name: "TT - 8J (2008 - 2015)",
            //             value: "tt-8j"
            //         },
            //         {
            //             name: "TT - 8S (2016 - 2021)",
            //             value: "tt-8s"
            //         }
            //     ]
            // },
            {
                value: "tt-s/tt-rs",
                name: "TT-S/TT-RS",
                series: [
                    {
                        name: "TT-S - 8J (2008 - 2015)",
                        value: "tt-s-8j",
                        title: "AUDI - 8J (2008 - 2015) - TT-S",
                        description: "Transform your 2008-2015 8J MK2 | Audi TT-S with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    {
                        name: "TT-S - 8S (2016 - 2019)",
                        value: "tt-s-8s",
                        title: "AUDI - 8S (2016 - 2019) - TT-S",
                        description:"Transform your 2016-2019 8S MK3 Audi TT-S with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    {
                        name: "TT-S - MK3 Facelift (2020-2023)",
                        value: "tt-s-8s-5",
                        title: "AUDI - MK3 Facelift (2020-2023) - TT-S",
                        description:"Transform your 2020-2023 8S.5 MK3 Audi TT-S with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                     {
                        name: "TT-RS - 8J.5 (2012 - 2013)",
                        value: "tt-rs-8j-5",
                        title: "AUDI - 8J.5 (2012 - 2013) - TT-RS",
                        description: "Transform your 2008-2015 8J MK2 | Audi TT-RS with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    {
                        name: "TT-RS - 8S (2018 - 2019)",
                        value: "tt-rs-8s",
                        title: "AUDI - 8S (2018 - 2019) - TT-RS",
                        description:"Transform your 2016-2019 8S MK3 Audi TT-RS with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    },
                    {
                        name: "TT-RS - MK3 Facelift (2020-2023)",
                        value: "tt-rs-8s-5",
                        title: "AUDI - MK3 Facelift (2020-2023) - TT-RS",
                        description:"Transform your 2020-2023 8S.5 MK3 Audi TT-RS with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and High quality, our body kits will not disappoint."
                    }
                ]
            },
           {
                value: "r8",
                name: "R8",
                series: [
                    {
                        name: "R8 - MK1 (2007 - 2012)",
                        value: "r8-mk1",
                        title: "AUDI - MK1 (2007 - 2012) - R8",
                        description:"Transform your 2007-2012 MK1 Audi R8 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
{
                        name: "R8 - MK1 Facelift (2013 - 2015)",
                        value: "r8-mk1-facelift",
                        title: "AUDI - MK1 (2013 - 2015) - R8",
                        description:"Transform your 2013-2015 MK1 Facelift Audi R8 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                  {
                        name: "R8 - MK2 (2016 - 2023)",
                        value: "r8-mk2",
                        title: "AUDI - MK2 (2016 - 2023) - R8",
                        description:"Transform your 2016-2023 MK2 Audi R8 with CAP's high-quality Carbon Fiber, Front Bumpers, Grilles and Accessories! Perfect fitment and best-priced, our body kits will not disappoint."
                    },
                ]
            },
        ],
        "BMW": [
            {
                value: "2-series",
                name: "2 Series",
                series: [
                    {
                        name: "G42 2-Series (2021 - 2024)",
                        value: "g42-2-series",
                        title: "BMW - G42 2-Series (2021 - 2024)",
                      
                    }
                ]
            },
            {
                value: "3-series",
                name: "3 Series",
                series: [
                    {
                        name: "E90 (2006 - 2011)",
                        value: "e90-3-series",
                        title: "BMW - E90 (2006 - 2011)"
                    },
                    {
                        name: "E92 (2006 - 2011)",
                        value: "e92-3-series",
                        title:"BMW - E92 (2006 - 2011)",
                    },
                    {
                        name: "F30 (2012 - 2018)",
                        value: "f30-3-series",
                        title: "BMW - F30 (2012 - 2018)"
                    },
                    {
                        name: "G20 (2019 - 2022)",
                        value: "g20-3-series",
                        title: "BMW - G20 (2019 - 2022)",
                    }
                ]
            },
           {
                value: "4-series",
                name: "4 Series",
                series: [
                  {
                        name: "G22 (2021 - 2024)",
                        value: "g22-4-series",
                        title: "BMW - G22 (2021 - 2024)",
                    }
                ]
            },
{
                value: "5-series",
                name: "5 Series",
                series: [
                    {
                        name: "F10 (2011 - 2017)",
                        value: "f10-5-series",
                        title: "BMW - F10 (2011 - 2017)",
                    },
                    {
                        name: "G30 (2018 - 2022)",
                        value: "g30-5-series",
                        title: "BMW - G30 (2018 - 2022)",
                    },
                ]
            },
            {
                value: "m2",
                name: "M2",
                series: [
                    {
                        name: "G87 M2 (2021 - 2024)",
                        value: "g87-m2",
                        title: "BMW - G87 M2 (2021 - 2024)",
                    }
                  
                ]
            },
           {
                value: "m3",
                name: "M3",
                series: [
                    {
                        name: "F80 M3 (2015 - 2018)",
                        value: "f80-m3",
                        title: "BMW - F80 M3 (2015 - 2018)",
                    },
                   {
                        name: "G80 M3 (2020 - 2024)",
                        value: "g80-m3",
                        title: "BMW - G80 M3 (2020 - 2024)",
                    }
                ]
            },
           {
                value: "m4",
                name: "M4",
                series: [
                    {
                        name: "F82 M4 (2015 - 2020)",
                        value: "f82-m4",
                        title: "BMW - F82 M4 (2015 - 2020)",
                    },
                   {
                        name: "G82 M4 (2021 - 2024)",
                        value: "g82-m4",
                        title: "BMW - G82 M4 (2021 - 2024)",
                    },
                   {
                        name: "G83 M4 (2021 - 2024)",
                        value: "g83-m4",
                        title: "BMW - G83 M4 (2021 - 2024)",
                    }
                ]
            },
            {
                value: "m5",
                name: "M5",
                series: [
                   {
                        name: "F10 M5 (2011 - 2017)",
                        value: "f10-m5",
                        title: "BMW - F10 M5 (2011 - 2017)",
                    },
                    {
                        name: "F90 M5 (2018 - 2022)",
                        value: "f90-m5",
                        title: "BMW - F90 M5 (2018 - 2022)",
                    }
                ]
            },
           {
                value: "m6",
                name: "M6",
                series: [
                     {
                        name: "F13 M6 (2011 - 2017)",
                        value: "f13-m6",
                        title: "BMW - F13 M6 (2011 - 2017)",
                    }
                ]
            }
            
        ],
        "Mercedes": [
            {
                value: "c-class",
                name: "C Class",
                series: [
                    {
                        name: "W204 (2007 - 2014)",
                        value: "w204",
                        title: "MERCEDES - W204 (2007 - 2014)",
                    },
                    {
                        name: "W205 (2015 - 2022)",
                        value: "w205",
                        title: "MERCEDES - W205 (2015 - 2022)",
                    }, {
                        name: "W206 (2022 - 2024)",
                        value: "w206",
                        title: "MERCEDES - W205 (2022 - 2024)",
                    }
                ]
            },
            {
                value: "e-class",
                name: "E Class",
                series: [
                    {
                        name: "W212 (2010 - 2016)",
                        value: "w212",
                        title: "MERCEDES - W212 (2010 - 2016)",
                    },
                    {
                        name: "W213 (2017+)",
                        value: "w213",
                        title: "MERCEDES - 213 (2017+)",
                    }
                ]
            }, {
                value: "cla-class",
                name: "CLA Class",
                series: [
                    {
                        name: "C118 (2020 - 2023)",
                        value: "c118",
                        title: "MERCEDES - C118 (2020 - 2023)",
                    },
                ]
            },
        ],
        "Tesla": [
    {
      "value": "model-3",
      "name": "Model 3",
      "series": [
        {
          "name": "Model 3 (2017 - 2023)",
          "value": "model-3",
          "title": "Tesla - Model 3 (2017 - 2023)"
        },
      ]
    },
    {
      "value": "model-y",
      "name": "Model Y",
      "series": [
        {
          "name": "Model Y (2020 - 2023)",
          "value": "model-y",
          "title": "Tesla - Model Y (2020 - 2023)"
        },
      ]
    }
  ],
        "Volkswagen": [
            {
                value: "golf-mk7",
                name: "Golf",
                series: [
                    {
                        name: "Golf - MK7 (2015 - 2018)",
                        value: "golf-mk7",
                        title: "VOLKSWAGEN - MK7 (2015 - 2018) - Golf",
                    }, {
                        name: "Golf - MK7.5 (2019 - 2021)",
                        value: "golf-mk7-5",
                        title: "VOLKSWAGEN - MK7.5 (2019 - 2021) - Golf",
                    },{
                        name: "Golf - MK8 (2022 - 2024)",
                        value: "golf-mk8",
                        title: "VOLKSWAGEN - MK8 (2022 - 2024) - Golf",
                    },
                ]
            },
            {
                value: "gti-mk7",
                name: "GTI",
                series: [
                    {
                        name: "GTI - MK7 (2015 - 2018)",
                        value: "gti-mk7",
                        title: "VOLKSWAGEN - MK7 (2015 - 2018) - GTI",
                    },{
                        name: "GTI - MK7.5 (2019 - 2021)",
                        value: "golf-gti-mk7-5",
                        title: "VOLKSWAGEN - MK7.5 (2019 - 2021) - GTI",
                    },{
                        name: "GTI - MK8 (2022 - 2024)",
                        value: "gti-mk8",
                        title: "VOLKSWAGEN - MK8 (2022 - 2024) - GTI",
                    }
                ]
            },
            {
                value: "golf-r",
                name: "Golf R",
                series: [
                    {
                        name: "Golf R - MK7 (2015 - 2018)",
                        value: "golf-r-mk7",
                        title: "VOLKSWAGEN - MK7 (2015 - 2018) - Golf R",
                    },{
                        name: "Golf R - MK7.5 (2019 - 2021)",
                        value: "golf-r-mk7-5",
                        title: "VOLKSWAGEN - MK7.5 (2019 - 2021) - Golf R",
                    },{
                        name: "Golf R - MK8 (2022 - 2024)",
                        value: "golf-r-mk8",
                        title: "VOLKSWAGEN - MK8 (2022 - 2024) - Golf R",
                    }
                ]
            },
        ],
        "Infiniti": [
            {
                value: "q50-160",
                name: "Q50/Q60",
                series: [
                    {
                        value: "q50-q60-3.0t",
                        name: "3.0T (2016+)",
                        title: "INFINITI - 3.0T (2016+)",
                    }
                ]
            }
        ],
        "Honda": [
            {
                value: "civic",
                name: "Civic",
                series: [
                    {
                        value: "civic-tenth-generation",
                        name: "Tenth Generation (2016+)",
                        title: "HONDA - Tenth Generation (2016+)",
                    }
                ]
            },
        ],
        "Toyota": [
            {
                value: "supra",
                name: "Supra",
                series: [
                    {
                        value: "supra-j29-db",
                        name: "J29/DB (2019+)",
                        title: "TOYOTA - 29/DB (2019+)"
                    }
                ]
            },
        ]
    };